module.exports = __webpack_public_path__ + "media/images/listras02-07bc160db24837b394a4c7f0ca743ddf.png";